<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FRWvXl/tc-custom/9781488092237.jpg?1705539641631" alt="This image is the cover for the book Stranger in His Bed, The Masters of Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stranger in His Bed, The Masters of Texas
      </h1>
      <p class="bookDescription body article font2">
        <b>He says he’s her husband. But with her memory shattered, can she trust him—and give in to temptation? “A scrumptious and sensual story for romance fans!” —<i>Fresh Fiction</i></b><br/><br/>Victoria Masters remembers nothing after the accident that stole her past, not even her name. Now she’s living in a billionaire rancher’s palatial home and finding this sensual stranger impossible to resist. He says he’s her husband, but why does she get the sense he’s holding back? <br/><br/>Now, as a powerful desire leads her into Wade’s bed, a surprise she’ll never forget is in store . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauren Canan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68385652